import Model from "./Model";
import {
  Company,
  ComparisonGroup,
  UserTaxonomy,
  ProductSector,
  ProductCategory,
  ProductClass,
  Media,
} from ".";

export default class Alert extends Model {
  static type = "alertLaunches";

  name!: string;

  alertables!: Array<
    | ComparisonGroup
    | Company
    | ProductSector
    | ProductCategory
    | ProductClass
    | { id: string; type: string }
  >;
  alertableType!: string;

  media?: Media | null;
  alertType = "alertLaunches";

  enabled!: boolean;
  frequency!: string;
  recipients!: string[];

  get isComparisonGroup() {
    return this.alertableType === ComparisonGroup.type;
  }

  get isEntry() {
    return this.alertableType === Company.type;
  }

  get isTaxonomy() {
    return this.alertableType === UserTaxonomy.type;
  }

  get isRadio() {
    if (this.media?.id == undefined) {
      return true;
    }

    return this.media.id == "1";
  }

  get isTV() {
    if (this.media?.id == undefined) {
      return true;
    }

    return this.media.id == "2";
  }

  // eslint-disable-next-line
  constructor(data: any, included = []) {
    super(data, included);

    this.alertableType = ComparisonGroup.type;
    if (this.alertables) {
      const [first] = this.alertables;
      if (first instanceof Company) {
        this.alertableType = Company.type;
      } else if (first instanceof ComparisonGroup) {
        this.alertableType = ComparisonGroup.type;
      } else {
        this.alertableType = UserTaxonomy.type;
      }
    } else {
      this.alertables = [];
    }

    if (!this.recipients) {
      this.recipients = [];
    }

    if (!this.frequency) {
      this.frequency = "never";
    }

    if (this.media == undefined) {
      this.media = new Media({});
    }
  }

  get alertablesData() {
    return (
      this.alertables?.map((e) => {
        if (e instanceof Company) {
          return { id: e.id, type: "companies" };
        } else if (e instanceof ComparisonGroup) {
          return { id: e.id, type: "comparisonGroups" };
        } else {
          return { id: e.id, type: e.type };
        }
      }) || []
    );
  }

  getPostData() {
    return {
      name: this.name,
      alertables: this.alertablesData,
      mediaId: this.media?.id || null,
      type: this.alertType,
      frequency: this.frequency,
      recipients: this.recipients,
    };
  }
}
